import { intersection } from 'lodash';

import {
  CRITICAL_POIS_CATEGORIES,
  EDIT_SUGGESTION_LABELS,
} from '../constants/constants';

/**
 * @param payload payload of editSuggestion prepared to be sent to API
 * @param item current selected active item in UI
 */
export const enhanceEditSuggestoinPayload = (payload, item) => {
  const isCriticalPOIAffected =
    intersection(CRITICAL_POIS_CATEGORIES, item?.properties?.poi_category)
      .length > 0;

  if (isCriticalPOIAffected) {
    if (!payload.labels) payload.labels = [];

    if (!payload.labels.includes(EDIT_SUGGESTION_LABELS.critical_poi)) {
      payload.labels.push(EDIT_SUGGESTION_LABELS.critical_poi);
    }
  }
};

export const getReferrer = () => {
  const urlSearchParams = new URLSearchParams(window.location.href);
  const utmCampaign = urlSearchParams.get('utm_campaign');
  if (utmCampaign !== 'referrer') return null;
  return urlSearchParams.get('utm_source');
};
